
import { TrendingUp, Shield, Clock } from 'lucide-react';
import { Language } from '@/i18n/types';
import { commonLabels } from '@/i18n';

export const getValuePropositionCards = (language?: Language) => {
  const labels = commonLabels(language);
  const cardsData = labels.menuPages?.howItWorks?.valuePropositionSection?.cards || [];
  
  const icons = [TrendingUp, Shield, Clock];
  const gradients = [
    "from-orange-600/30 via-amber-600/20 to-yellow-600/30",
    "from-pink-600/30 via-rose-600/20 to-fuchsia-600/30",
    "from-lime-600/30 via-green-600/20 to-emerald-600/30"
  ];
  const glowColors = ["orange-400", "pink-400", "lime-400"];
  const borderColors = ["border-orange-400/30", "border-pink-400/30", "border-lime-400/30"];
  const delays = [0, 0.2, 0.4];
  
  return cardsData.map((card: any, index: number) => ({
    id: index + 1,
    title: card.title || "",
    description: card.description || "",
    icon: icons[index] || icons[0],
    gradient: gradients[index] || gradients[0],
    glowColor: glowColors[index] || glowColors[0],
    borderColor: borderColors[index] || borderColors[0],
    delay: delays[index] || 0
  }));
};

// Fallback for backwards compatibility
export const valuePropositionCards = [
  {
    id: 1,
    title: "Konkurrensskraftigt Bud",
    description: "Vi erbjuder marknadens bästa priser genom vårt breda nätverk av köpare och samarbetspartners.",
    icon: TrendingUp,
    gradient: "from-orange-600/30 via-amber-600/20 to-yellow-600/30",
    glowColor: "orange-400",
    borderColor: "border-orange-400/30",
    delay: 0
  },
  {
    id: 2,
    title: "Trygg & Snabb Process",
    description: "Säker försäljning med direkt betalning och garanterad process utan krångel.",
    icon: Shield,
    gradient: "from-pink-600/30 via-rose-600/20 to-fuchsia-600/30",
    glowColor: "pink-400",
    borderColor: "border-pink-400/30",
    delay: 0.2
  },
  {
    id: 3,
    title: "Total Transparens",
    description: "Tydlig process från start till mål - du förstår exakt vad som händer i varje steg.",
    icon: Clock,
    gradient: "from-lime-600/30 via-green-600/20 to-emerald-600/30",
    glowColor: "lime-400",
    borderColor: "border-lime-400/30",
    delay: 0.4
  }
];
